import { inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { catchError, EMPTY, Observable } from "rxjs";
import { AppInfoResponse, VersionInfo } from "../types/info-application.types";
import { baseUrl } from "../../../constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class InfoApplicationApiService {
  private http = inject(HttpClient);

  public fetchVersionBack(): Observable<AppInfoResponse> {
    return this.http.get<AppInfoResponse>(`${baseUrl}/actuator/info`).pipe(
      catchError(() => EMPTY)
    );
  }

  public fetchChangelogBack(): Observable<string> {
    return this.http.get(`${baseUrl}/admin/changelog`, {responseType: 'text'}).pipe(
      catchError(() => EMPTY)
    );
  }

  public fetchVersionFront(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>('assets/version.json').pipe(
      catchError(() => EMPTY)
    );
  }

  public fetchChangelogFront(): Observable<string> {
    return this.http.get('assets/RELEASE_NOTES.md', { responseType: 'text' }).pipe(
      catchError(() => EMPTY)
    );
  }
}
